<template>
  <el-dialog title="召回国际退款" :visible.sync="visible" width="520px" append-to-body @closed="onClosed">
    <el-form label-width="90px">
      <el-form-item label="召回原因" required>
        <el-input
          v-model="reason"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 5}"
          maxlength="4000"
          show-word-limit
          placeholder="请输入召回原因"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { overseasRefundRecall } from '@/API';

export default {
  name: 'OverseasRefundRecallDialog',
  data () {
    return {
      visible: false,
      submitting: false,
      overseasRefundId: null,
      reason: ''
    };
  },
  methods: {
    open (overseasRefundId) {
      this.overseasRefundId = overseasRefundId;
      this.reason = '';
      this.visible = true;
    },
    onClosed () {
      this.overseasRefundId = null;
      this.reason = '';
    },
    submit () {
      if (!this.reason) {
        return this.$message.warning('请输入召回原因');
      }
      this.submitting = true;
      overseasRefundRecall({ overseasRefundId: this.overseasRefundId, reason: this.reason })
        .then((res) => {
          // axios 拦截器业务失败仍会 resolve 并弹出错误；此处必须判 status
          const status = res && res.data && res.data.status;
          if (status === '200') {
            this.visible = false;
            this.$emit('on-ok');
            this.$message.success('召回成功');
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
